import { ColorDefinitionRGBA } from './types';

export const asColorDefinitionRGBA = <T>(
  et: { [K in keyof T]: ColorDefinitionRGBA }
) => et;
